import MeetingLocationsEdit from './MeetingLocationsEdit';
import MeetingLocationsCreate from './MeetingLocationsCreate';

export default {
    edit: MeetingLocationsEdit,
    create: MeetingLocationsCreate,
};
